'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _life_at_hs_icon_ = require('../assets/life_at_hs_icons/life_at_hs_icon_1.png');

var _life_at_hs_icon_2 = _interopRequireDefault(_life_at_hs_icon_);

var _life_at_hs_icon_3 = require('../assets/life_at_hs_icons/life_at_hs_icon_2.png');

var _life_at_hs_icon_4 = _interopRequireDefault(_life_at_hs_icon_3);

var _life_at_hs_icon_5 = require('../assets/life_at_hs_icons/life_at_hs_icon_3.png');

var _life_at_hs_icon_6 = _interopRequireDefault(_life_at_hs_icon_5);

var _life_at_hs_icon_7 = require('../assets/life_at_hs_icons/life_at_hs_icon_4.png');

var _life_at_hs_icon_8 = _interopRequireDefault(_life_at_hs_icon_7);

var _life_at_hs_icon_9 = require('../assets/life_at_hs_icons/life_at_hs_icon_5.png');

var _life_at_hs_icon_10 = _interopRequireDefault(_life_at_hs_icon_9);

var _life_at_hs_icon_11 = require('../assets/life_at_hs_icons/life_at_hs_icon_6.png');

var _life_at_hs_icon_12 = _interopRequireDefault(_life_at_hs_icon_11);

var _life_at_hs_icon_13 = require('../assets/life_at_hs_icons/life_at_hs_icon_7.png');

var _life_at_hs_icon_14 = _interopRequireDefault(_life_at_hs_icon_13);

var _life_at_hs_icon_15 = require('../assets/life_at_hs_icons/life_at_hs_icon_8.png');

var _life_at_hs_icon_16 = _interopRequireDefault(_life_at_hs_icon_15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var imagePaths = [_life_at_hs_icon_2['default'], _life_at_hs_icon_4['default'], _life_at_hs_icon_6['default'], _life_at_hs_icon_8['default'], _life_at_hs_icon_10['default'], _life_at_hs_icon_12['default'], _life_at_hs_icon_14['default'], _life_at_hs_icon_16['default']];
var makeImage = function makeImage(imagePath) {
    return _react2['default'].createElement('img', { src: imagePath });
};
var images = imagePaths.map(makeImage);

function LifeAtHelloSign() {
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--life-at-hellosign' },
        _react2['default'].createElement(
            'h2',
            null,
            'Life at HelloSign'
        ),
        _react2['default'].createElement(
            'p',
            null,
            'We have raving fans ',
            images[0],
            ' who love what we make \u2022 We\u2019re always evolving with eye towards improvement ',
            images[1],
            ' \u2022 We\u2019re committed to building a product people want ',
            images[2],
            ' \u2022 We actively build our culture together as a team ',
            images[3],
            ' \u2022 We work in an open, airy, creative space with communal dining and lounge spaces ',
            images[4],
            ' \u2022 We thrive on teaching and learning from each other ',
            images[5],
            ' \u2022 We laugh a lot ',
            images[5],
            ' \u2022 And we\u2019ll never forget your birthday! ',
            images[6]
        )
    );
}

module.exports = LifeAtHelloSign;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/careers-page/life-at-hellosign/index.jsx
 ** module id = 1565
 ** module chunks = 0
 **/